module.exports = __webpack_public_path__ + "img/bet_amount_icon.00bb0a43.svg";